module.exports = __webpack_public_path__ + "img/2_1-macerie-2.0cc6080c.png";